<template>
  <div v-if="!islocset">
    <h3 class="ml-4">You don't have any location, Create one!</h3>
    <br />
    <vs-button type="filled" class="ml-3" color="#6eda78" @click="createloc"
      >Create Location</vs-button
    >
  </div>
  <div v-else>
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Location Setting</li>
    </vs-breadcrumb>

    <!-- <b-breadcrumb style="background-color: #ffffff; ">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Location Setting</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <div slot="header">
      <vs-row>
        <h3 class="ml-2 headerText">&nbsp;&nbsp;Location Setting</h3> </vs-row
      ><br />
    </div>
    <vs-row>
      <vs-col vs-type="flex" vs-lg="6" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <vs-alert
            class="mt-2"
            active="true"
            color="success"
            icon="bookmark_border"
            >Select asset to Add or Delete asset, Then click Save</vs-alert
          >
          <br />
          <br />
          <vs-row>
            <vs-spacer />
            <vs-tooltip text="Add New Asset" position="top">
              <vs-button
                v-b-modal.modal-1
                :disabled="!events[0].value || lock"
                class="mr-2"
                color="primary"
                type="flat"
                icon="add"
                >Add</vs-button
              ></vs-tooltip
            >
            <vs-tooltip text="Copy Asset" position="top">
              <vs-button
                class="text-dark mr-2"
                color="dark"
                type="flat"
                icon="content_copy"
                :disabled="true"
                >Copy</vs-button
              ></vs-tooltip
            >
            <vs-tooltip text="Delete Asset" position="top">
              <vs-button
                class="text-danger mr-2"
                color="danger"
                type="flat"
                icon="delete"
                @click="del"
                :disabled="!events[0].value || lock"
                >Delete</vs-button
              ></vs-tooltip
            >
          </vs-row>
          <div @click="a = true" ref="tree" class="dhx-container--tree"></div>

          <!-- <div><vs-spacer /><vs-button type="filled" class="ml-3" color="#6eda78" @click="save(1)">Save</vs-button></div> -->

          <!-- <span v-if="lock" style="padding-left: 2.5%; font-size: 130%">Please save before <b>Add</b> or <b>Delete</b> another asset</span> -->
          <!-- <treelist
          class="item"
          :item="treeData"
          @make-folder="makeFolder"
          @add-item="addItem"
        ></treelist> -->
        </vs-card>
        <!-- <vs-button type="filled" @click="callapi" color="red">!!! RESET DATA !!!</vs-button> -->
      </vs-col>
      <vs-col vs-type="flex" vs-lg="6" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <h5 class="mt-2">Asset Detail</h5>

          <vs-input
            style="width: 100%"
            class="mt-4"
            placeholder="Asset Name"
            label="Asset Name"
            v-model="AssetDetailName"
            :disabled="!viewDetail.value"
          />
          <vs-select
            multiple
            class="mt-3"
            style="width: 100%"
            label="Sensor List (Option)"
            :disabled="!viewDetail.value"
            v-model="viewDetail.sens"
          >
            <vs-select-item
              :key="index"
              :value="item.serial_id"
              :text="item.name"
              v-for="(item, index) in senslist"
            />
          </vs-select>

          <vs-input
            class="mt-3"
            style="width: 100%"
            placeholder="Infomation"
            label="Infomation"
            v-model="viewDetail.info"
            :disabled="!viewDetail.value"
          />

          <br />
          <vs-row class="mt-2 mb-3" vs-w="12">
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <vs-button
                class="bts"
                color="success"
                @click="saveEdit"
                type="filled"
                >Save</vs-button
              >
              <vs-button class="ml-2" color="dark" @click="cancel1" type="flat"
                >Cancel</vs-button
              >
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <b-modal
      id="modal-1"
      title="Add New Asset"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      size="lg"
    >
      <vs-row vs-w="12">
        <vs-col
          v-if="swap == false"
          vs-type="flex"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <h6>Parent Asset : {{ events[0].value }}</h6>
        </vs-col></vs-row
      >
      <!-- <p class="my-4">Hello from modal!</p> -->

      <vs-row v-if="swap == false" class="mb-1" vs-w="12">
        <vs-col
          class="mt-4 mb-1"
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <h6>Children Asset :</h6>
          <vs-input
            class="ml-2"
            style="width: 330px"
            placeholder="New Location name"
            v-model="newloc"
          />
        </vs-col>
        <vs-col
          class="mt-4"
          vs-type="flex"
          vs-align="center"
          vs-lg="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            type="filled"
            size="sm"
            style="border-radius: 20px"
            color="warning"
            :disabled="newloc == ''"
            @click="checkName('', 1), (swap = !swap)"
            >Check Name</vs-button
          >
        </vs-col>
      </vs-row>

      <div v-if="swap == true">
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">
            <h6>Parent Asset : {{ events[0].value }}</h6>
          </vs-col>
          <vs-col class="mt-4" vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">
            <h6>Children Asset : {{ newloc }}</h6>
          </vs-col>
        </vs-row>

        <vs-row class="mt-4 mb-2" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <h6>Sensor List (Option)</h6>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-select
              multiple
              width="80%"
              class="selectExample"
              v-model="select1"
            >
              <vs-select-item
                :key="index"
                :value="item.serial_id"
                :text="item.name"
                v-for="(item, index) in senslist"
              />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="mt-3 mb-2" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <h6>New Asset :</h6>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-input
              style="width: 80%"
              placeholder="New Location name"
              v-model="newinfo"
            />

            <!-- <vs-textarea  label="New Asset"   v-model="newinfo" /> -->
          </vs-col>
        </vs-row>
      </div>

      <template #modal-footer="{}">
        <vs-button
          v-if="swap == true"
          class="bts"
          color="success"
          type="filled"
          v-b-modal.modal-save
          @click="acceptAlert"
          :disabled="!checkValid"
          >Add</vs-button
        >
        <b-button
          class="ml-1"
          id="btncancel"
          variant="light"
          @click="cancel1()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
    <!-- <b-modal id="modal-center" centered title="Delete Selected Item">
    <p class="my-4">Are you sure?</p> 
     <template #modal-footer="{  }"> -->

    <!-- <vs-button  class=" mr-2 "  size="small"  color="danger" type="filled" @click="del">Delete</vs-button> -->
    <!-- Button with custom close trigger value -->

    <!-- <vs-button color="primary"   size="small" type="filled" @click="save(1)">Save</vs-button>
      <b-button size="sm" variant="outline-secondary" @click="cancel1">
        Cancel
      </b-button>
    </template>
    
  </b-modal> -->

    <b-modal id="modal-delete" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Selected Item</b
        >
      </template>
      <p class="my-4">Do you want to delete item?</p>
      <template #modal-footer="{}">
        <vs-button color="dark" size="sm" @click="cancel1" type="flat"
          >Cancel</vs-button
        >
        <vs-button
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="save(1)"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>
    <b-modal id="modal-save" centered title="Save New Asset">
      <p class="my-4">Add New Asset</p>
      <template #modal-footer="{}">
        <vs-button class="bts" color="success" type="filled" @click="save(1)"
          >Save</vs-button
        >
        <b-button class="ml-1" id="btncancel" variant="light" @click="cancel1">
          Cancel
        </b-button>
        <!-- <vs-button color="primary"   size="small" type="filled" @click="save(1)">Save</vs-button> -->
        <!-- <b-button size="sm" variant="danger"  @click="cancel1">
        Cancel
      </b-button> -->
      </template>
    </b-modal>
    <!-- <vs-prompt
    @cancel="val='',select1=[]"
    @accept="acceptAlert"
    :active.sync="active"
    :is-valid="checkValid"
    title="Add New Asset">
      <div class="con-exemple-prompt">
        Current Selected
        <vs-input placeholder="Selected" readonly v-model="events[0].value"/><br>
        New Location Name
        <vs-input placeholder="Infomation"  v-model="newinfo"/><vs-button type="filled" :disabled="newinfo == ''" @click="checkName('',1)">Check Name</vs-button><br><br>
        
        Information        
        <vs-input placeholder="New Asset" v-model="newloc"/><br>
        Sensor List<vs-select
          multiple
          class="selectExample"
          v-model="select1">
          <vs-select-item :key="index" :value="item.serial_id" :text="item.name" v-for="(item,index) in senslist" />
        </vs-select>
      </div>
    </vs-prompt> -->
    <vs-prompt
      @cancel="val = ''"
      @accept="del"
      :active.sync="active2"
      title="Delete Selected Item"
    >
      <div class="con-exemple-prompt">Are you sure?</div>
    </vs-prompt>
    <!-- <vs-prompt
    @cancel="inputitem=''"
    @accept="confirmadd"
    :active.sync="active3"
    title="Delete Selected Item">
      <div class="con-exemple-prompt">
        <vs-input v-model="inputitem"></vs-input>
      </div>
    </vs-prompt> -->
  </div>
</template>

<script>
import fromCDN from "from-cdn";
import { Tree as TreeDHX, TreeCollection } from "dhx-suite";
// import Treelist from "../dashboard/Location/Treelist"
export default {
  name: "LocationSetting",
  // components: {
  //   Treelist
  // },
  data: () => ({
    checkValid: false,
    dupName: false,
    a: false,
    swap: false,
    checkValidDetail: false,
    text: "Select asset to Add or Delete asset, Then click Save",
    select1: [],
    newinfo: "",
    treeData: {
      name: "My Tree",
      children: [
        { name: "hello" },
        { name: "wat" },
        {
          name: "child folder",
          children: [
            {
              name: "child folder",
              children: [{ name: "hello" }, { name: "wat" }],
            },
            { name: "hello" },
            { name: "wat" },
            {
              name: "child folder",
              children: [{ name: "hello" }, { name: "wat" }],
            },
          ],
        },
      ],
    },
    data: new TreeCollection(),
    events: [{ value: "" }],
    tree: null,
    b: false,
    f: false,
    senstree: null,
    senslist: [],
    dupsensor: [],
    initialsensors: null,
    active: false,
    active2: false,
    active3: false,
    newloc: "",
    initiallocation: null,
    check: true,
    lock: false,
    islocset: true,
    viewDetail: { value: "", info: "", sens: [] },
    AssetDetailName: "",
  }),
  methods: {
    log() {
      // console.log(this.treeData)
    },
    findpos(loc) {
      // console.log(loc)
      if (this.newloc == "") this.newloc = "Default Name";
      this.findloop(this.initiallocation, loc, this.newloc);
    },
    createloc() {
      this.$API
        .get("createnewloc/")
        .then(() => {
          this.$vs.notify({
            title: "Create New Location",
            text: "Complete!",
            color: "primary",
            position: "top-center",
          });
          setTimeout(() => {
            location.reload();
          }, 300);
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Create New Location",
            text: "Error!",
            color: "danger",
            position: "top-center",
          });
          // console.log(err)
        });
    },
    findloop(loc1, loc, newloc) {
      loc1.forEach((el) => {
        // console.log(el)
        if (el.value == loc) {
          if (!el.items) {
            el.items = [];
            el.items.push({
              value: newloc,
              id: newloc,
              sens: this.select1,
              info: this.newinfo,
            });
          } else {
            // if(this.select1[0] != undefined && this.select1[0] != null)
            el.items.push({
              value: newloc,
              id: newloc,
              sens: this.select1,
              info: this.newinfo,
            });
            // else
            // el.items.push({value:newloc,id:newloc})
          }
          // // console.log("Found!")
        }
        if (el.items) {
          this.findloop(el.items, loc, newloc);
        }
      });
    },
    finddelloop(loc1, loc) {
      var index = 0;
      loc1.forEach((el) => {
        // console.log(el)
        if (el.value == loc) {
          index = loc1.indexOf(el);
          loc1.splice(index, 1);
          // console.log(index)
        }
        if (el.items) {
          this.finddelloop(el.items, loc);
        }
      });
    },
    findnameloop(loc, name) {
      loc.forEach((el) => {
        // console.log(el)
        if (el.value == name) {
          this.dupName = true;
        }
        if (el.items) {
          this.findnameloop(el.items, name);
        }
      });
    },
    finddetail(loc, name) {
      loc.forEach((el) => {
        // // console.log(el)
        if (el.value == name) {
          this.viewDetail = el;
          if (!this.viewDetail.sens) {
            this.viewDetail.sens = [];
          }
          // // console.log(this.viewDetail)
        }
        if (el.items) {
          this.finddetail(el.items, name);
        }
      });
    },
    findforedit(loc, name) {
      loc.forEach((el) => {
        // // console.log(el)
        if (el.value == name) {
          el = this.viewDetail;
        }
        if (el.items) {
          this.finddetail(el.items, name);
        }
      });
    },
    cancel1() {
      location.reload();
    },
    del() {
      this.lock = true;
      this.finddelloop(this.initiallocation, this.events[0].value);
      // console.log(this.initiallocation)
      this.tree.destructor();
      this.tree = new TreeDHX(this.$refs.tree, {
        data: this.initiallocation,
        dragMode: "both",
        dropBehaviour: "complex",
        css: "custom-class",
        icon: {
          file: "fas fa-folder",
        },
      });
      this.$bvModal.show("modal-delete");
    },
    add() {
      this.active = true;
    },
    acceptAlert() {
      this.lock = true;
      this.findpos(this.events[0].value);
      // console.log(this.initiallocation)
      this.tree.destructor();
      this.tree = new TreeDHX(this.$refs.tree, {
        data: this.initiallocation,
        dragMode: "both",
        dropBehaviour: "sibling",
        editable: true,
        css: "custom-class",
        icon: {
          file: "fas fa-folder",
        },
      });
      this.$bvModal.hide("modal-1");
    },
    saveEdit() {
      this.viewDetail.value = this.AssetDetailName;
      this.viewDetail.id = this.AssetDetailName;
      // this.findforedit(this.beforeData,this.viewDetail.value)
      // // console.log(this.viewDetail)
      // // console.log(this.initiallocation)
      this.save(2);
    },
    checkName(name, mode) {
      // console.log(name)
      this.dupName = false;
      if (mode == 1) this.findnameloop(this.initiallocation, this.newloc);
      if (mode == 2) this.findnameloop(this.initiallocation, name);
      if (this.dupName) {
        if (mode == 1) this.checkValid = false;
        if (mode == 2) this.checkValidDetail = false;
        this.$vs.notify({
          title: "Add Asset",
          text: "Duplicate Name!!",
          color: "danger",
          position: "top-center",
        });
      } else {
        if (mode == 1) this.checkValid = true;
        if (mode == 2) this.checkValidDetail = true;
        this.$vs.notify({
          title: "Add Asset",
          text: "This name is valid",
          color: "success",
          position: "top-center",
        });
      }
    },
    callapi() {
      this.$API.post("hierarchy").then(() => {
        location.reload();
      });
    },
    save(mode) {
      this.$vs.loading();
      this.dupsensor = [];
      var afterData = "";
      var filter = "";
      console.log(this.viewDetail)
      // this.checkAvailableSensor()
      // // console.log(this.dupsensor)
      if (mode == 1) afterData = this.tree.data.serialize();
      if (mode == 2) {
        // console.log(this.initiallocation)
        afterData = this.initiallocation;
      }
      // console.log(afterData)
      filter = this.socketremove(afterData);
      // eslint-disable-next-line no-console
      // console.log(JSON.stringify(filter))
      this.$API
        .post("savelist", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          token: this.$session.get("token"),
          tree: JSON.stringify(filter),
          dupsensor: this.viewDetail.sens,
          location: this.viewDetail.value,
        })
        .then(() => {
          location.reload();
        });
    },
    socketremove(item) {
      var con;
      item.forEach((el) => {
        Object.keys(el).forEach((e) => {
          con = e.includes("$");
          // eslint-disable-next-line no-console
          // // console.log(con)
          if (con) delete el[e];
          if (e == "items") {
            // eslint-disable-next-line no-console
            // // console.log(Object.values(el[e]))
            this.socketremove(Object.values(el[e]));
          }
        });
      });
      // eslint-disable-next-line no-console
      // console.log(item)
      return item;
    },
    checkAvailableSensor() {
      var main = this.tree.data.serialize();
      // eslint-disable-next-line no-console
      // // console.log(main)
      var listsensor = [];
      this.initialsensors[0].items.forEach((e) => {
        listsensor.push(e.value);
      });
      // eslint-disable-next-line no-console
      // // console.log(listsensor)
      this.removeUnavailable(main, this.initialsensors[0].items);
    },
    removeUnavailable(main, ls) {
      // eslint-disable-next-line no-console
      // console.log(ls)
      main.forEach((el) => {
        Object.keys(el).forEach((e) => {
          if (e == "value") {
            ls.forEach((network) => {
              // eslint-disable-next-line no-console
              // console.log(network)
              network.items.forEach((sensor) => {
                if (sensor.value == el[e]) {
                  this.dupsensor.push(sensor);
                }
              });
            });
          }
          if (e == "items") {
            this.removeUnavailable(Object.values(el[e]), ls);
          }
        });
      });
    },
    makeFolder(item) {
      this.$set(item, "children", []);
      this.addFolderChild(item);
    },
    addFolderChild(item) {
      item.children.push({
        name: this.inputitem,
      });
    },
    addItem(item) {
      this.active3 = true;
      // console.log(item)
      Object.keys(treeData).forEach(() => {});
      this.treeData.findIndex();
    },
    confirmadd(item) {
      item.children.push({
        name: this.inputitem,
      });
    },
  },
  mounted() {
    // this.tree = [
    //   {value:'test',name:'test1',items:[
    //     {value:'test',name:'test12',items:[
    //       {value:'test',name:'test123',items:[
    //       ]}
    //     ]}
    //   ]},
    //   {value:'test',name:'test1',items:[
    //     {value:'test',name:'test12',items:[
    //       {value:'test',name:'test123',items:[
    //       ]}
    //     ]}
    //   ]}
    // ]
    const sensurl = "uncatasensor/";
    this.$API.get(sensurl).then((result) => {
      this.senslist = result.data;
      // console.log(this.senslist)
    });
    const url = this.$url + "listview/" + this.$session.get("token");
    // eslint-disable-next-line no-console
    // console.log(url)
    fromCDN([
      "https://cdn.dhtmlx.com/suite/edge/suite.js",
      "https://cdn.dhtmlx.com/suite/edge/suite.css",
    ]).then(() => {
      this.tree = new TreeDHX(this.$refs.tree, {
        data: this.data,
        dragMode: "both",
        dropBehaviour: "sibling",
        css: "custom-class",
        icon: {
          file: "fas fa-folder",
        },
      });
      this.data
        .load(url)
        .then(() => {
          // console.log(this.tree.data.serialize())
          this.initiallocation = this.tree.data.serialize();
        })
        .catch((err) => {
          this.islocset = false;
          console.log(err)
        });
      // this.sensdata.load(sensurl).then(() => {
      //   this.initialsensors = this.senstree.data.serialize()
      // })
      this.tree.events.on("itemClick", (id, e) => {
        this.viewDetail = { value: "", info: "", sens: [] };
        this.AssetDetailName = id;
        this.finddetail(this.initiallocation, id);
        const keyId = Math.random();
        // this.events = [{ keyId, name: "itemClick", value: id }].concat(this.events);
        this.events = [{ keyId, name: "Click", value: id }];
        console.log(this.viewDetail)
      });
    });
  },
};
</script>

<style>
.custom-class {
  padding: 20px;
}
ul.dhx_widget.dhx_tree.custom-class {
  overflow: hidden;
}
.custom-class .dhx_tree-list-item__text {
  color: #0ab169;
}
.custom-class .dhx_tree-folder .dhx_tree-list-item__text {
  color: #0288d1;
}
.vs-select--item.con-icon.activex {
  padding-left: 30px;
}
</style>
<style scoped>
.bts {
  width: 70px;
  border-radius: 20px;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>